const udhrPreamble = `Rakger
O vezañ ma'z eo war anaout an dellezegezh enstag ouzh holl izili an denelezh hag o gwirioù par ha diwerzhus eo diazezet ar frankiz, ar reizhded hag ar peoc'h,

 o vezañ ma'z eo war dizanaout ha dismegañsiñ gwirioù mab-den eo bet ganet an aktoù a varbariezh a sav koustiañs mab-den en o enep, ha ma'z eo bet embannet eo donedigezh ur bed a vo ennañ gant an dud frankiz da gomz ha da grediñ, dieubet ma vint diouzh ar spont hag an dienez, a zo mennad uhelañ mab-den,

o vezañ ma'z eo ret-holl diwall gwirioù mabden gant reolenn al lezenn evit na vefe ket rediet an dud d'en em sevel ouzh an tirantegezh hag ar gwaskerezh da rekour diwezhañ,

o vezañ ma'z eo ret-holl kas war-raok an darempredoù a vignoniezh etre ar broadoù,

o vezañ ma'z eo bet embannet adarre er Garta gant pobloù ar Broadoù-Unanet o feiz e gwirioù diazez mab-den, e dellezegezh ha talvoudegezh mab-den, e parded ar baotred hag ar merc'hed en o gwirioù, ha ma'z eo bet disklêriet ganto e oant mennet da gas war-raok an diorroadur kevredigezhel ha da wellaat an aozioù-buhez en ur frankiz vrasoc'h,

o vezañ ma'z eo bet gouestlet gant ar Stadoù-Ezel diogeliñ, gant kenlabour Aozadur ar Broadoù-Unanet, an doujañs hollvedel ha gwirion ouzh gwirioù mab-den hag ar frankizioù pennan,

hago vezañ ma'z eo a bouez bras kengompren ar gwirioù hag ar frankizioù-mañ a-benn seveniñ ar gouestl,

evel uhelvennad boutin da vezañ diraezet gant an holl bobloù hag an holl vroadoù, d'an holl dud hag ensavadurioù, gant an Disklêriadur-mañ atav en o freder, da lakaat kreskiñ dre ar c'helenn hag an deskadurezh, an doujans ouzh ar gwirioù ha frankizioù-mañ, d'o lakaat da vezañ anavezet ha sevenet tamm-ha-tamm da vat hag e pep lec'h, dre ziarbennoù broadel hag etrevroadel, koulz e-touez pobloù ar Stadoù-Ezel hag e-touez ar re zo war zouaroù dindan o lezennoù.

EZ EMBANN
AR VODADEG-VEUR
DISKLERIADUR HOLLVEDEL GWIRIOÙ MABDEN`;
const udhr1 = `Dieub ha par en o dellezegezh hag o gwirioù eo ganet an holl dud. Poell ha skiant zo dezho ha dleout a reont bevañ an eil gant egile en ur spered a genvreudeuriezh.`;

module.exports = {
    name: "Breton",
    udhrPreamble,
    udhr1,
    lang: 'br',
}